import React from 'react'
import Layout from '../../common/Layout'
import ContactPage from './ContactPage'
import * as styles from './_ContactPage.scss'
import withStyles from 'isomorphic-style-loader/withStyles'

export default ({
  path: '/adviser/:adviserName/:id/contact',

  async action ({ params }) {
    const adviserId = parseInt(params.id)
    var adviserName = decodeURIComponent(params.adviserName.split('_').join(' '))
    return {
      title: `Allan Gray | ${adviserName} | Contact`,
      component: <Layout adviserName={adviserName} className={styles['no-padding']} containerWell backButtonText={'Back to adviser'}><ContactPage adviserId={adviserId} adviserName={adviserName} /></Layout>
    }
  }
})
